import React, { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import assetsManager from "../assets/assetsmanager/assestsmanager";
import { authenticateUser } from "../hooks/authenticateUser";
const Login = () => {
  const navigate = useNavigate();
  const [payload, setPayload] = useState({
    userId: "",
    password: ""
  });
  const [loading, setLoading] = useState(false);
  const [visiblePass, setVisiblePass] = useState("password");
  const [invalidUserId, setInvalidUserId] = useState(false);
  const [invalidPassword, setInvalidPassword] = useState(false);
  let toastId;
  const creds = [
    {
      userName: "celebal",
      userId: "admin@celebaltech.com",
      password: "123123"
    }
  ];
  // const handleLogin = async (e, userId, password) => {
  //   e !== "" && e?.preventDefault();
  //   let isUserIdValid = validateFormInput(
  //     "userId",
  //     userId ? userId : payload?.userId
  //   );
  //   let isPasswordValid = validateFormInput(
  //     "password",
  //     password ? password : payload?.password
  //   );
  //   setInvalidUserId(isUserIdValid);
  //   setInvalidPassword(isPasswordValid);
  //   if (!isUserIdValid && !isPasswordValid) {
  //     setLoading(true);
  //     toast.dismiss();
  //     toast.loading("loading...");
  //     try {
  //       // const response = await login(
  //       //   userId ? userId : payload.userId,
  //       //   password ? password : payload.password
  //       // );
  //       // localStorage.setItem("tab", response?.data[0]?.tab);
  //       // localStorage.setItem("authToken", response?.data[0]?.token);
  //       // localStorage.setItem("userName", response?.data[0]?.username);
  //       // dispatch({
  //       //   type: "AUTH_TOKEN",
  //       //   payload: response?.data[0]?.token,
  //       // });
  //       // dispatch({
  //       //   type: "AI_CONVERSER_CHAT",
  //       //   payload: response?.data[1]?.ai_driven?.reverse(),
  //       // });
  //       // dispatch({
  //       //   type: "DATA_DRIVEN_CHAT",
  //       //   payload: response?.data[1]?.data_driven?.reverse(),
  //       // });
  //       // toast.dismiss(toastId);
  //       setTimeout(() => {
  //         localStorage.setItem("adminAuthToken", "adminAuthToken");
  //         navigate("/admin/pdf");
  //         setLoading(false);
  //         toast.dismiss();
  //       }, 3000);
  //     } catch (err) {
  //       toast.dismiss();
  //       setLoading(false);
  //       // if (err?.message == "Authentication Failed ") {
  //       //   toastId = toast.error("Invalid Credentials");
  //       // } else if (err?.message == "Check User ID or Password") {
  //       //   toastId = toast.error("Invalid Credentials");
  //       // } else {
  //       //   toastId = toast.error("Some error");
  //       // }
  //     }
  //   }
  // };

  // const handleLogin = async (e) => {
  //   e.preventDefault();
  //   let isUserIdValid = validateFormInput("userId", payload?.userId);
  //   let isPasswordValid = validateFormInput("password", payload?.password);
  //   setInvalidUserId(isUserIdValid);
  //   setInvalidPassword(isPasswordValid);
  //   if (!isUserIdValid && !isPasswordValid) {
  //     setLoading(true);
  //     toast.dismiss(toastId);
  //     toastId = toast.loading("loading...");

  //     setTimeout(() => {
  //       setLoading(false);
  //       toast.dismiss(toastId);
  //       creds?.find((user, i) => {
  //         if (
  //           user.userId === payload.userId &&
  //           user.password === payload.password
  //         ) {
  //           localStorage.setItem("adminAuthToken", "adminAuthToken");
  //           localStorage.setItem("userName", user.userName);
  //           toast.success("Login SuccessFul");
  //           navigate("/admin/pdf");
  //         } else {
  //           toast.error("Invalid Credentials");
  //         }
  //       });
  //     }, 3000);
  //   }
  // };

  async function handleLogin(e) {
    e.preventDefault();
    let isUserIdValid = validateFormInput("userId", payload?.userId);
    let isPasswordValid = validateFormInput("password", payload?.password);

    setInvalidUserId(isUserIdValid);
    setInvalidPassword(isPasswordValid);

    if (!isUserIdValid && !isPasswordValid) {
      setLoading(true);
      toast.dismiss();
      toast.loading("Authenticating...");
      try {
        const response = await authenticateUser(payload);
        if (response === true) {
          localStorage.setItem(
            "adminAuthToken",
            response?.token || "temp token"
          );
          toast.dismiss();
          toast.success("Login successful");
          navigate("/admin/pdf");
        } else {
          toast.dismiss();
          toast.error("Invalid credentials");
        }
      } catch (error) {
        toast.dismiss();
        toast.error(error?.message || "Invalid credentials");
      } finally {
        // localStorage.setItem("adminAuthToken", "temp token");
        setLoading(false);
      }
    }
  }
  const updatePayload = (e) => {
    setInvalidUserId("");
    setInvalidPassword("");
    setPayload({
      ...payload,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="loginPage flex w-full">
      <div className="left md:w-[65%] w-full bg-[#f3dbd8] flex items-center lg:justify-start justify-center">
        <div className="login-cont w-[21rem] ml-[5%] bg-white shadow-md rounded-lg p-8 z-10">
          <h4 className="text-3xl font-bold text-[#383636]">Login</h4>
          <span className="text-[#383636]">
            Please enter the following details
          </span>
          <form onSubmit={handleLogin}>
            <div className="mt-2 h-[77px]">
              <label className="text-sm">User name</label>
              <input
                className={`border-[1.5px] border-[#3D3D3D] w-full p-2 text-sm rounded-[4px] login-input ${
                  invalidUserId ? "incorrect-input" : ""
                }`}
                name="userId"
                value={payload?.userId}
                placeholder="abc@something.com"
                onChange={updatePayload}
                autoComplete="off"
              />
              {invalidUserId && (
                <div className="errorMessage text-xs text-[#C7222A]">
                  {invalidUserId}
                </div>
              )}
            </div>
            <div className="h-[77px]">
              <label className="text-sm">Password</label>
              <div className="relative">
                <input
                  className={`border-[1.5px] border-[#3D3D3D] w-full p-2 text-sm rounded-[4px] login-input ${
                    invalidPassword ? "incorrect-input" : ""
                  }`}
                  type={visiblePass}
                  name="password"
                  value={payload?.password}
                  placeholder="*********"
                  onChange={updatePayload}
                  autoComplete="off"
                />
                <div className="absolute right-[12px] top-[50%] transform translate-y-[-8px] h-100 w-fit cursor-pointer">
                  {payload.password.length > 0 && (
                    <>
                      {visiblePass === "text" ? (
                        <img
                          className="h-[16px]"
                          src={assetsManager.view}
                          alt=""
                          onClick={() => {
                            setVisiblePass("password");
                          }}
                        />
                      ) : (
                        <img
                          className="h-[16px]"
                          src={assetsManager.hide}
                          alt=""
                          onClick={() => setVisiblePass("text")}
                        />
                      )}
                    </>
                  )}
                </div>
              </div>
              {invalidPassword && (
                <div className="errorMessage text-xs text-[#C7222A]">
                  {invalidPassword}
                </div>
              )}
            </div>
            <div className="flex justify-end">
              {/* <div className="errorMessage text-[0.8rem] text-[#C7222A]">
                forgot password?
              </div> */}
            </div>
            <div className="mt-2">
              <button
                className="bg-[#C7222A] text-white px-20 w-full mt-1 py-[6px] rounded-[4px]"
                type="submit"
                disabled={loading}
              >
                Sign In
              </button>
            </div>
          </form>
        </div>
        <img
          className="absolute bottom-0 h-20 z-0"
          src={assetsManager.loginBgLeft}
          alt=""
        />
      </div>
      <div className="right w-[35%] bg-[#3c3c3c] relative">
        <img
          className="w-[100%] h-full object-cover object-bottom max-w-none"
          src={assetsManager.loginBgRight1}
          alt=""
        />
        <img
          className=" 2xl:w-[34rem] w-[27rem]  h-full absolute top-0 transform translate-x-[-33%]"
          src={assetsManager.loginBgRight2}
          alt=""
        />
      </div>
    </div>
  );
};

export default Login;

const validateFormInput = (name, value) => {
  switch (name) {
    case "userId": {
      if (value?.length === 0) {
        return "User name is required";
      } else {
        return "";
      }
    }
    case "password": {
      if (value?.length === 0) {
        return "Password is required";
      } else {
        return "";
      }
    }

    default: {
      if (value?.length === 0) {
        return `${name} is required`;
      } else {
        return "";
      }
    }
  }
};
